import { gql } from "@apollo/client";
import { baseFragments } from "queries/fragments";

export const calculatePriceQuery = gql`
  ${baseFragments.money}
  ${baseFragments.rental.price}
  
  query calculatePrice(
    $id: Int!
    $departure_date: String!
    $return_date: String!
    $delivery_location: String
    $coupon_code: String
    $insurance_package: Int
    $add_ons: [Int]
    $good_sam_membership_package: String
    $is_trip_interruption_insurance: Boolean
    $no_split_payments: Boolean
    $date_of_birth: String
    $rental_type: Int
    $specific_delivery_location_id: Int
    $additional_insurances: [Int]
  ) {
    calculate_price(
      rv: $id
      departure_date: $departure_date
      return_date: $return_date
      delivery_location: $delivery_location
      coupon_code: $coupon_code
      insurance_package: $insurance_package
      add_ons: $add_ons
      good_sam_membership_package: $good_sam_membership_package
      is_trip_interruption_insurance: $is_trip_interruption_insurance
      no_split_payments: $no_split_payments
      date_of_birth: $date_of_birth
      rental_type: $rental_type
      specific_delivery_location_id: $specific_delivery_location_id
      additional_insurances: $additional_insurances
    ) {
      result {
        success
        errors {
          code
          message
        }
      }
      price {
        ...RentalPrice
      }
      price_form_detailed {
        desc {
          id
          value
          type
        }
        total {
          cents_total
          dollars_as_part
          cents_as_part
          user_friendly
        }
        items {
          id
          type
          title {
            id
            value
            type
          }
          value {
            id
            value
            type
          }
          style
          separ
          sub_items {
            title {
              id
              value
              type
            } 
            value {
              id
              value
              type
            }
            units
          }
          action {
            title
            id
            pos
          }
        }
      }
    }
  }
`;
